import { TextField } from '@fluentui/react';
import * as React from 'react';
import { BeesInvoiceModel } from '../models/BeesInvoiceModel';
import { Utils } from '../../common/views/Utils';
import BeesInvoicePrintView from './BeesInvoicePrintView';
import { useBeesInvoiceVM } from '../viewmodels/BeesInvoiceVM';

export type BeesInvoiceProps = {
    token: string;
    year: number;
    month: number;
}

export default function BeesInvoiceView({ token, year, month }: BeesInvoiceProps) {
    const hasLoaded = React.useRef(false);
    const vm = useBeesInvoiceVM(token, year, month);

    const width1 = Utils.getColumnWidth(1);
    const width2 = Utils.getColumnWidth(2);

    React.useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList();
    }, [vm]);

    const footerForm = () => {
        return <div className="no-print ms-Grid-row pl-8 pr-8 pt-10">
            <div className={width2 + " pt-5 right"}>Start Invoice #</div>
            <div className={width1}>
                <TextField
                    placeholder="Start Inv"
                    value={vm.startNo}
                    onChange={(_, v) => { vm.setStartNo(v ?? "1") }} />
            </div>
            <div className={width2 + " font-bold pt-5"}>
                Total: ${getTotal()}
            </div>
        </div>;
    }

    const printRow = (invoice: BeesInvoiceModel, index: number) => {
        const invoiceNo = "INV" + year + "-" + String((parseInt(vm.startNo) + index)).padStart(4, '0');

        return <>
            {index > 0 && <div className="page-break"></div>}
            <BeesInvoicePrintView invoice={invoice} invoiceNo={invoiceNo} />
        </>;
    }

    const getTotal = () => {
        return Utils.getSum(vm.invoices, "amount");
    }

    return <div className="left" style={{ width: "1040px" }}>
        {footerForm()}

        <div className="ms-Grid" key={vm.listHash}>
            {vm.invoices.map(printRow)}
        </div>
    </div>;
}